import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

export const tablePrimaryButtonSx: SystemStyleObject<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  height: 32,
  px: '10px',
  borderRadius: '8px',
  fontSize: '11px',
  fontWeight: 500,
  lineHeight: 1,
  textTransform: 'none',
  color: '#ffffff',
  backgroundColor: '#1b2559',
  border: '1px solid #1b2559',
  transition: 'background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease',
  '&:hover:not(:disabled)': {
    backgroundColor: '#0f172a',
    borderColor: '#0f172a',
  },
  '&:disabled': {
    opacity: 0.55,
    cursor: 'not-allowed',
  },
  '.MuiSvgIcon-root': {
    fontSize: '16px',
  },
};
